import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum OpportunityStatusIds {
  OPEN = 1,
  SOME_CLOSED = 9,
  CLOSED = 10,
  CLOSED_WON = 11,
  REOPENED = 12,
  REOPENED_SOME_CLOSED_WON = 13,
  REOPENED_SOME_CLOSED = 14,
  SOME_CLOSED_WON = 15,
  NOT_SET = 16,
}

export function getOpportunityStatii(): ISelectItem[] {
  return [
    { id: OpportunityStatusIds.OPEN, label: 'Open', disabled: true },
    {
      id: OpportunityStatusIds.SOME_CLOSED,
      label: 'Some Closed',
      disabled: true,
    },
    {
      id: OpportunityStatusIds.SOME_CLOSED_WON,
      label: 'Some Clsd Won',
      disabled: true,
    },
    { id: OpportunityStatusIds.CLOSED, label: 'Closed', disabled: true },
    {
      id: OpportunityStatusIds.CLOSED_WON,
      label: 'CLOSED WON',
      disabled: true,
    },
    {
      id: OpportunityStatusIds.REOPENED,
      label: 'Reopened',
      disabled: true,
    },
    {
      id: OpportunityStatusIds.REOPENED_SOME_CLOSED_WON,
      label: 'Reopened Some Clsd Won',
      disabled: true,
    },
    {
      id: OpportunityStatusIds.REOPENED_SOME_CLOSED,
      label: 'Reopened Some Clsd',
      disabled: true,
    },
    {
      // The server's label too. It read 'Reopened Some Clsd', a copy of id
      // 14's, so a Not Set opportunity showed as Reopened Some Clsd.
      id: OpportunityStatusIds.NOT_SET,
      label: 'Not Set',
      disabled: true,
    },
  ]
}

/**
 * The statuses an opportunity is FINISHED in: every service closed, won or not.
 * Everything else -- Open, the Some Closed / Some Clsd Won mixes, the Reopened
 * family, and the Not Set error trap -- still has something in play.
 *
 * Keyed by ID: the server's id 1 is labelled 'Lead' where the webapp says
 * 'Open' (Opportunity() remaps it), so a label is not a stable identity.
 */
export const TERMINAL_OPPORTUNITY_STATUS_IDS: readonly OpportunityStatusIds[] =
  [OpportunityStatusIds.CLOSED, OpportunityStatusIds.CLOSED_WON]

/** True for any status that is not terminal -- see TERMINAL_OPPORTUNITY_STATUS_IDS. */
export function isOpenOpportunityStatus(statusId: number | undefined): boolean {
  return !TERMINAL_OPPORTUNITY_STATUS_IDS.includes(
    statusId as OpportunityStatusIds
  )
}

export const getOpportunityStatusByLabel =
  getItemByLabelFactory(getOpportunityStatii)

export const getOpportunityStatusById = getItemByIdFactory(getOpportunityStatii)
